const validateEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default validateEmail;
